import { Form, useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { updateFormInformation } from "../../api/survey";
import Button from "../../components/ButtonUI";
import { addSharedObjectToFront } from "../../components/CreationSteps";
import Input from "../../components/FloatInput";
import SelectComp from "../../components/Select";
import makeToast from "../../components/Snackbar";

type Props = {
  survey: any;
  closeModal: any;
  visteList: any[];
  setRefresh: any;
  randomConfig: any;
};

const EditEproSurvey = (props: Props) => {
  const { t } = useTranslation();
  const { survey, closeModal, visteList, setRefresh, randomConfig } = props;
  const [groups, setGroups] = useState(
    randomConfig
      ? randomConfig.groups.map((g: any) => {
          return {
            label: `${g?.groupName}`,
            value: g?._id,
          };
        })
      : [{ label: "Shared", value: "shared" }],
  ) as any[];
  const [isShared, setIsShared] = useState<boolean>(true);

  const getChange = (newValues, oldValues) => {
    if (
      newValues.name === oldValues.name &&
      newValues.description === oldValues.description &&
      newValues.associatedGroup === oldValues.associatedGroup
    ) {
      if (
        oldValues.dependency &&
        oldValues.dependency.length > 0 &&
        oldValues.dependency[0] === newValues.dependency
      ) {
        return true;
      } else if (
        oldValues.dependency &&
        oldValues.dependency.length === 0 &&
        newValues.dependency === ""
      ) {
        return true;
      } else return false;
    } else return false;
  };
  const formatPayload = (newValues, oldValues) => {
    if (getChange(newValues, oldValues)) {
      return null;
    } else {
      let obj: any = {};
      if (newValues.name !== oldValues.name) {
        obj["name"] = newValues.name;
      }
      if (newValues.description !== oldValues.description) {
        obj["description"] = newValues.description;
      }
      if (
        (oldValues.dependency &&
          oldValues.dependency.length > 0 &&
          oldValues.dependency[0] !== newValues.dependency) ||
        (oldValues.dependency &&
          oldValues.dependency.length === 0 &&
          newValues.dependency !== "")
      ) {
        obj["dependency"] = newValues.dependency;
      }
      if (newValues.associatedGroup !== oldValues.associatedGroup) {
        obj["associatedGroup"] = newValues.associatedGroup;
        if (
          oldValues.shared &&
          newValues.associatedGroup &&
          (newValues.associatedGroup !== null ||
            newValues.associatedGroup !== "" ||
            newValues.associatedGroup !== "shared")
        ) {
          obj["shared"] = false;
        }
        if (
          (!oldValues.shared || oldValues.associatedGroup) &&
          (!newValues.associatedGroup ||
            newValues.associatedGroup === "" ||
            newValues.associatedGroup === "shared")
        ) {
          obj["shared"] = true;
        }
      }

      return obj;
    }
  };
  const handleSubmit = async (values, survey) => {
    const res = await updateFormInformation(
      formatPayload(values, survey),
      survey._id,
    );

    if (res) {
      setRefresh((r) => !r);
      makeToast("success", t("missingWording.fet1"));
      closeModal();
    } else {
      makeToast("error", t("missingWording.pht2"));
    }
  };

  const formik = useFormik({
    initialValues: {
      name: survey.name,
      description: survey.description,

      dependency:
        survey.dependency && survey.dependency.length > 0
          ? survey.dependency[0]
          : "",
      associatedGroup: survey.associatedGroup ?? null,
      shared: randomConfig ? isShared : true,
    },

    onSubmit: (values) => {},
  });

  return (
    <Form className="bg-white p-6 w-full flex flex-col ">
      <h3 className="font-bold text-2xl text-black text-center my-10 mx-6 px-24 ">
        {t("missingWording.visitInfos")}
      </h3>
      <div className=" mx-4 items-center my-3  ">
        <Input
          id="name"
          className="w-full"
          placeholder={t("missingWording.visitName")}
          labelText={t("missingWording.visitName")}
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          inlineLabel={false}
          onfocus={true}
          style={{ maxHeight: "50px" }}
        />
      </div>
      <div className="mx-4  items-center my-3  ">
        <Input
          id="description"
          className="w-full"
          placeholder={t("missingWording.fdi1")}
          labelText={t("missingWording.fdi1")}
          type="text"
          style={{ maxHeight: "50px" }}
          value={formik.values.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          inlineLabel={false}
          onfocus={true}
        />
      </div>

      {visteList.length > 0 && (
        <div className="mx-4  items-center mt-2 my-3">
          <label>{t("missingWording.fdi4")}</label>
          <SelectComp
            id="dependency"
            value={formik.values.dependency}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={!visteList || visteList.length === 0}
            className="min-w-full "
            text={
              visteList.length > 0
                ? `${t("missingWording.fdi4")}`
                : `${t("missingWording.fdi5")}`
            }
            options={visteList
              ?.filter((x: any) => x._id !== survey._id)
              .map((e) => {
                return { value: e?._id, label: e?.name };
              })}
          ></SelectComp>
        </div>
      )}

      {randomConfig && randomConfig?.groups && (
        <div className="mx-4  items-center mt-2 my-3 ">
          <label>{t("missingWording.inpXALabel")}</label>
          <SelectComp
            id="associatedGroup"
            value={formik.values.associatedGroup}
            onChange={(e) => {
              if (e.target.value === "shared" || e.target.value === "") {
                setIsShared(true);
                formik.setFieldValue("associatedGroup", null);
              } else {
                setIsShared(false);
                formik.setFieldValue("associatedGroup", e.target.value);
              }
              return;
            }}
            disabled={!groups || groups.length === 0}
            className="min-w-full mb-8"
            text={`${
              groups.length > 0
                ? t("missingWording.inpXA")
                : t("missingWording.inpXAn")
            }`}
            options={addSharedObjectToFront(groups, t)}
          ></SelectComp>
        </div>
      )}

      <Button
        disabled={formik.values.name === "" || getChange(formik.values, survey)}
        status="primary"
        className="px-6 py-2 mt-5 mb-2"
        onClick={async () => {
          handleSubmit(formik.values, survey);
        }}
      >
        {t("missingWording.save")}
      </Button>
    </Form>
  );
};

export default EditEproSurvey;
